<template>
    <span class="CPillWrapper inline-flex items-center" :class="{ 'mr-0.5': props.showComma }">
        <span
            class="CPill group inline-flex max-w-[min(64rem,100%)] items-center rounded leading-none"
            :class="pillClasses"
            @click="handleClick"
        >
            <CIcon v-if="props.icon && props.icon !== 'hashtag'" class="shrink-0" :class="iconClasses" :name="props.icon" size="small" />
            <span class="hashtag-break text-sm" :class="{ 'font-semibold': props.icon === 'hashtag' }"><slot>{{ props.text }}</slot></span>
            <slot name="end" />
        </span><span v-if="props.showComma" class="text-sm font-normal">,</span>
    </span>
</template>

<script setup lang="ts">
import CIcon from '@/components/ui/CIcon.vue'
import { computed } from 'vue'

const _variants = ['gray', 'white', 'plain'] as const
type Variant = (typeof _variants)[number]

interface Props {
    text?: string
    icon?: string | null
    variant?: Variant
    greenIcon?: boolean
    showComma?: boolean
}

const props = withDefaults(defineProps<Props>(), {
    text: '',
    icon: 'hashtag',
    variant: 'gray',
    greenIcon: false,
    showComma: false
})

const emit = defineEmits<{
    (e: 'click', event: MouseEvent): void
}>()

const hasClickHandler = computed(() => true)

const pillClasses = computed(() => ({
    'rounded-3xl bg-gray-300 dark:bg-subtle py-2 pl-2 pr-4': props.variant === 'gray',
    'rounded-3xl bg-white dark:bg-surface-card py-2 pl-2 pr-4 shadow-card-box': props.variant === 'white',
    'cursor-pointer hover:underline': hasClickHandler.value
}))

const iconClasses = computed(() => ({
    'group-hover:text-black group-hover:dark:text-txt-headings': hasClickHandler.value,
    'text-green-500': props.greenIcon,
    'text-gray-700 dark:text-txt-body': !props.greenIcon
}))

const handleClick = (event: MouseEvent) => {
    if (hasClickHandler.value) {
        emit('click', event)
    }
}
</script>

<style lang="postcss" scoped>
.hashtag-break {
    word-break: break-word;
}
</style>
